var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "campaign-booking-list-item",
      attrs: { tag: "li", to: _vm.bookingLink },
    },
    [
      _c("div", { staticClass: "flex flex-col w-2/3" }, [
        _c("div", { staticClass: "campaign-booking-list-item__name" }, [
          _vm._v(_vm._s(_vm.booking.name)),
        ]),
        _vm._v(" "),
        _vm.booking.opportunities
          ? _c(
              "div",
              { staticClass: "flex flex-row flex-wrap" },
              _vm._l(_vm.booking.opportunities, function (opportunity) {
                return _c(
                  "div",
                  {
                    key: opportunity.id,
                    staticClass: "flex flex-row align-center",
                  },
                  [
                    _c("div", { staticClass: "bullet-point" }),
                    _vm._v(_vm._s(opportunity.name) + "\n      "),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-1/3" }, [
        _c("div", { staticClass: "flex flex-row align-center" }, [
          _vm.booking.client
            ? _c("div", { staticClass: "w-2/5" }, [
                _vm._v(
                  _vm._s(_vm.booking.client.company) +
                    " / " +
                    _vm._s(_vm.booking.client.name)
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "w-1/5 flex flex-row justify-center" }, [
            _c("span", [
              _c("i", { staticClass: "fa fa-user" }),
              _vm._v(" " + _vm._s(_vm.booking.required_stars)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-2/5 flex flex-row justify-end spacer-r-1" },
            [
              _c("booking-status-label", {
                staticStyle: { "overflow-x": "hidden" },
                attrs: { booking: _vm.booking },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }